/* global axios */
import ApiClient from '../ApiClient';

class EnterpriseAccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true, enterprise: true });
  }

  checkout() {
    return axios.post(`${this.url}checkout`);
  }

  subscription() {
    return axios.post(`${this.url}subscription`);
  }

  async getLimits() {
    try {
      const response = await axios.get(`${this.url}limits`);
      return response;
    } catch (error) {
      // 404 is expected when not in Chatwoot Cloud environment
      if (error.response?.status !== 404) {
        throw error;
      }
      // Return empty response for non-Cloud environments
      return { data: {} };
    }
  }

  toggleDeletion(action) {
    return axios.post(`${this.url}toggle_deletion`, {
      action_type: action,
    });
  }

  createTopupCheckout(credits) {
    return axios.post(`${this.url}topup_checkout`, { credits });
  }
}

export default new EnterpriseAccountAPI();
